export const LINKS = [
  { link: "/", label: "Home" },
  { link: "/office", label: "Office" },
  { link: "/lifestyle", label: "Lifestyle" },
  { link: "/location", label: "Location" },
  { link: "/gallery", label: "Gallery" },
  { link: "/leasing", label: "Leasing" },
  { link: "/film", label: "Film" },
];

export default {};
